import React from "react";
import {
    Modal,
    Box,
    Typography,
    CircularProgress,
    IconButton,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import ShareIcon from "@mui/icons-material/Share";
import CloseIcon from "@mui/icons-material/Close";
// import IconButton from "@mui/material";
const ShareModal = ({ open, onClose, shareData, loading }) => {
    const handleCopy = (url) => {
        navigator.clipboard.writeText(url);
        alert("Link copied to clipboard!");
    };

    const icons = {
        facebook: <FacebookIcon sx={{ color: "#1877f2" }} />,
        twitter: <TwitterIcon sx={{ color: "#1da1f2" }} />,
        linkedin: <LinkedInIcon sx={{ color: "#0077b5" }} />,
        whatsapp: <WhatsAppIcon sx={{ color: "#25d366" }} />,
        instagram: <InstagramIcon sx={{ color: "#e1306c" }} />,
        email: <EmailIcon sx={{ color: "#ea4335" }} />,
        copy: <ContentCopyIcon sx={{ color: "#000" }} />,
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="share-modal"
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backdropFilter: "blur(3px)",
            }}
        >
            <Box
                sx={{
                    backgroundColor: "#fff",
                    padding: 3,
                    borderRadius: 3,
                    boxShadow: 24,
                    width: 300,
                    textAlign: "center",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 2,
                    }}
                >
                    <Typography variant="h6" sx={{marginLeft:"5%"}}>Share this story</Typography>

                    <IconButton onClick={onClose} sx={{ color: "#181717ff" }}>
                        <CloseIcon sx={{ fontSize: 30 }} />
                    </IconButton>
                </Box>

                {loading ? (
                    <CircularProgress />
                ) : (
                    <>
                        {shareData?.services?.map((s, i) => (
                            <Box
                                key={i}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 2,
                                    padding: "8px 12px",
                                    borderRadius: 2,
                                    "&:hover": { backgroundColor: "#f5f5f5" },
                                    cursor: "pointer",
                                }}
                                onClick={() =>
                                    s.service === "copy"
                                        ? handleCopy(s.share_url)
                                        : window.open(s.share_url, "_blank")
                                }
                            >
                                {icons[s.service] || <ShareIcon />}
                                <Typography textTransform="capitalize">
                                    {s.service}
                                </Typography>
                            </Box>
                        ))}
                    </>
                )}
            </Box>
        </Modal>
    );
};

export default ShareModal;
